/* ============================================================
   LUTIEN BRIDAL — shared site behaviour
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Tweaks state (shared via localStorage) ---------- */
  var LS = 'lutien.tweaks.v1';
  var DEFAULTS = {
    variant: 'b',        // a classic · b modern · c bold
    accent: '#E5B870',
    density: 'regular',  // compact · regular · airy
    bg: 'on',            // animated cursor background
    bgIntensity: 1,
    motion: 'on'
  };
  function loadTweaks() {
    var v = {};
    try { v = JSON.parse(localStorage.getItem(LS)) || {}; } catch (e) {}
    var out = {}; for (var k in DEFAULTS) out[k] = (k in v) ? v[k] : DEFAULTS[k];
    return out;
  }
  function saveTweaks(t) { try { localStorage.setItem(LS, JSON.stringify(t)); } catch (e) {} }
  window.LutienTweaks = { load: loadTweaks, save: saveTweaks, defaults: DEFAULTS };

  function applyTweaks(t) {
    var b = document.body, r = document.documentElement;
    if (b.hasAttribute('data-variantable')) b.setAttribute('data-variant', t.variant);
    r.style.setProperty('--accent', t.accent);
    var dens = t.density === 'compact' ? 0.74 : t.density === 'airy' ? 1.22 : 1;
    r.style.setProperty('--density', dens);
    b.setAttribute('data-bg', t.bg);
    r.style.setProperty('--bg-intensity', t.bgIntensity);
    b.setAttribute('data-motion', t.motion);
    window.dispatchEvent(new CustomEvent('lutien:tweaks', { detail: t }));
  }
  window.LutienTweaks.apply = applyTweaks;

  /* apply immediately (before paint where possible) */
  var T = loadTweaks();
  function boot() { applyTweaks(loadTweaks()); }
  if (document.body) boot(); else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('DOMContentLoaded', function () {
    applyTweaks(loadTweaks());

    /* ---------- Animated cursor background ---------- */
    var field = document.getElementById('bg-field');
    if (field) {
      var hasPointer = window.matchMedia('(pointer:fine)').matches;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var bgEnabled = document.body.getAttribute('data-bg') !== 'off';
      if (hasPointer && !reduceMotion && bgEnabled) {
        var glowA = field.querySelector('.glow:not(.b)');
        var glowB = field.querySelector('.glow.b');
        var tx = window.innerWidth * 0.5, ty = window.innerHeight * 0.34;
        var ax = tx, ay = ty, bx = tx, by = ty;
        var rafId = 0;
        window.addEventListener('pointermove', function (e) { tx = e.clientX; ty = e.clientY; }, { passive: true });
        function tick() {
          if (document.hidden) { rafId = 0; return; }
          ax += (tx - ax) * 0.045; ay += (ty - ay) * 0.045;
          bx += (tx - bx) * 0.018; by += (ty - by) * 0.018;
          if (glowA) glowA.style.transform = 'translate(' + ax + 'px,' + ay + 'px)';
          if (glowB) glowB.style.transform = 'translate(' + bx + 'px,' + by + 'px)';
          rafId = requestAnimationFrame(tick);
        }
        rafId = requestAnimationFrame(tick);
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden && !rafId) rafId = requestAnimationFrame(tick);
        });
      }
    }

    /* ---------- Header on scroll ---------- */
    var header = document.querySelector('.site-header');
    if (header) {
      var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 24); };
      onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    }

    /* ---------- Mobile nav ---------- */
    var burger = document.querySelector('.hamburger');
    var drawer = document.querySelector('.mobile-nav');
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        var open = drawer.classList.toggle('open');
        burger.classList.toggle('open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) drawer.removeAttribute('inert'); else drawer.setAttribute('inert', '');
        document.body.style.overflow = open ? 'hidden' : '';
      });
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          drawer.classList.remove('open'); burger.classList.remove('open');
          burger.setAttribute('aria-expanded', 'false');
          burger.setAttribute('aria-label', 'Open menu');
          drawer.setAttribute('aria-hidden', 'true');
          drawer.setAttribute('inert', '');
          document.body.style.overflow = '';
        });
      });
    }

    /* ---------- Reveal on scroll ---------- */
    var revealEls = [].slice.call(document.querySelectorAll('.reveal, .clip-up'));
    function revealInView() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = revealEls.length - 1; i >= 0; i--) {
        var el = revealEls[i];
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) {
          el.classList.add('in');
          revealEls.splice(i, 1);
        }
      }
    }
    revealInView();
    requestAnimationFrame(revealInView);
    var rTick = false;
    window.addEventListener('scroll', function () {
      if (rTick) return; rTick = true;
      requestAnimationFrame(function () { revealInView(); rTick = false; });
    }, { passive: true });
    window.addEventListener('resize', revealInView, { passive: true });
    setTimeout(function () {
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('in');
        el.style.transition = 'none';
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      document.querySelectorAll('.clip-up').forEach(function (el) {
        el.classList.add('in');
        [].forEach.call(el.children, function (c) { c.style.transition = 'none'; c.style.transform = 'none'; });
      });
    }, 1000);

    /* ---------- Section entrance animation ---------- */
    var sections = [].slice.call(document.querySelectorAll('.section'));
    function sectionsInView() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = sections.length - 1; i >= 0; i--) {
        var s = sections[i];
        var r = s.getBoundingClientRect();
        if (r.top < vh * 0.88) {
          s.classList.add('sec-in');
          sections.splice(i, 1);
        }
      }
    }
    sectionsInView();
    window.addEventListener('scroll', function() {
      requestAnimationFrame(sectionsInView);
    }, { passive: true });
    setTimeout(function() {
      document.querySelectorAll('.section').forEach(function(s) { s.classList.add('sec-in'); });
    }, 1200);

    /* ---------- Counter animation ---------- */
    var counted = false;
    function runCounters() {
      if (counted) return;
      var counters = document.querySelectorAll('.counter');
      if (!counters.length) return;
      var firstCounter = counters[0].getBoundingClientRect();
      if (firstCounter.top > window.innerHeight) return;
      counted = true;
      counters.forEach(function(el) {
        var target = parseInt(el.getAttribute('data-target'), 10);
        var suffix = el.getAttribute('data-suffix') || '';
        if (!target) return;
        var duration = 1200;
        var start = null;
        var startVal = Math.max(0, target - (target > 100 ? 200 : target));
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var ease = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(startVal + (target - startVal) * ease);
          if (target >= 1000) {
            el.textContent = current.toLocaleString() + suffix;
          } else {
            el.textContent = current + suffix;
          }
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }
    window.addEventListener('scroll', runCounters, { passive: true });

    /* ---------- Sketch form: Shopify Files image upload ---------- */
    (function () {
      var sketchForm = document.getElementById('sketchForm');
      if (!sketchForm) return;
      var drop = document.getElementById('cfDrop');
      var fileInput = document.getElementById('cfFiles');
      var thumbs = document.getElementById('cfThumbs');
      var uploadStatus = document.getElementById('cfUploadStatus');
      if (!drop || !fileInput || !thumbs) return;
      var store = [];
      var allowed = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
      var maxImages = 8, maxFileSize = 10 * 1024 * 1024, maxTotalSize = 50 * 1024 * 1024;
      var submitting = false;

      function message(text, error) {
        if (!uploadStatus) return;
        uploadStatus.textContent = text || '';
        uploadStatus.classList.toggle('is-error', !!error);
      }

      function totalSize() { return store.reduce(function (sum, item) { return sum + item.file.size; }, 0); }

      function attachmentLines() {
        return store.filter(function (item) { return item.state === 'Uploaded' && item.cdnUrl; })
          .map(function (item) { return item.name + ' — ' + item.cdnUrl; }).join('\n');
      }

      sketchForm.addEventListener('formdata', function (event) {
        var lines = attachmentLines();
        event.formData.set('contact[Inspiration image links]', lines);
      });

      function submitWithShopifyCaptcha() {
        if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
          window.Shopify.captcha.protect(sketchForm, function () { sketchForm.submit(); });
        } else {
          sketchForm.requestSubmit();
        }
      }

      function renderThumbs() {
        thumbs.innerHTML = '';
        store.forEach(function (item, i) {
          var t = document.createElement('div');
          t.className = 'cf-thumb';
          var img = document.createElement('img');
          img.src = item.url; img.alt = item.name;
          var state = document.createElement('span');
          state.className = 'cf-thumb-state cf-thumb-state-' + item.state.toLowerCase().replace(/[^a-z]+/g, '-');
          state.textContent = item.state === 'Failed' ? 'Upload failed · Retry' : item.state;
          var rm = document.createElement('button');
          rm.type = 'button'; rm.innerHTML = '&times;'; rm.setAttribute('aria-label', 'Remove photo');
          rm.addEventListener('click', function () {
            URL.revokeObjectURL(item.url);
            store.splice(i, 1);
            renderThumbs();
          });
          t.appendChild(img); t.appendChild(state); t.appendChild(rm); thumbs.appendChild(t);
        });
      }

      function addFiles(list) {
        var files = [].slice.call(list || []);
        files.forEach(function (f) {
          if (store.length >= maxImages) { message('You can add up to 8 images.', true); return; }
          if (allowed.indexOf(f.type) === -1) { message('Unsupported file type. Please use JPEG, PNG, WebP or GIF.', true); return; }
          if (f.size > maxFileSize) { message(f.name + ' is larger than 10 MB.', true); return; }
          if (totalSize() + f.size > maxTotalSize) { message('The total image size cannot exceed 50 MB.', true); return; }
          store.push({ file: f, name: f.name, url: URL.createObjectURL(f), state: 'Ready', cdnUrl: '' });
        });
        renderThumbs();
      }

      function uploadImages() {
        var pending = store.filter(function (item) { return item.state === 'Ready'; });
        if (!pending.length) return Promise.resolve(!store.some(function (item) { return item.state === 'Failed' || item.state === 'Uploading'; }));
        pending.forEach(function (item) { item.state = 'Uploading'; });
        renderThumbs(); message('Uploading your inspiration images…');
        var metadata = pending.map(function (item) { return { filename: item.name, mimeType: item.file.type, size: item.file.size }; });
        return fetch('/apps/lutien-upload/session', {
          method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ images: metadata })
        }).then(function (response) {
          if (!response.ok) throw new Error('Could not start image upload');
          return response.json();
        }).then(function (session) {
          if (!session.uploads || session.uploads.length !== pending.length) throw new Error('Upload session was incomplete');
          return Promise.all(session.uploads.map(function (remote, i) {
            var form = new FormData();
            remote.target.parameters.forEach(function (parameter) { form.append(parameter.name, parameter.value); });
            form.append('file', pending[i].file, remote.safeFilename);
            return fetch(remote.target.url, { method: 'POST', body: form }).then(function (response) {
              if (!response.ok) throw new Error('Staged upload failed');
              return response.text();
            });
          })).then(function () {
            return fetch('/apps/lutien-upload/complete', {
              method: 'POST', headers: { 'content-type': 'application/json' },
              body: JSON.stringify({ requestId: session.requestId, uploadIds: session.uploads.map(function (u) { return u.uploadId; }) })
            });
          }).then(function (response) {
          if (!response.ok) throw new Error('Could not complete image upload');
            return response.json();
          });
        }).then(function (result) {
          if (!result.uploads || result.uploads.length !== pending.length || result.uploads.some(function (u) { return u.status !== 'READY' || !u.url; })) throw new Error('Shopify did not finish processing an image');
          result.uploads.forEach(function (uploaded, i) { pending[i].state = 'Uploaded'; pending[i].cdnUrl = uploaded.url; });
          renderThumbs(); message('Images uploaded successfully.');
          return true;
        }).catch(function (error) {
          pending.forEach(function (item) { if (item.state === 'Uploading') item.state = 'Failed'; });
          renderThumbs(); message((error && error.message) || 'An image upload failed. Please retry.', true);
          return false;
        });
      }

      fileInput.addEventListener('change', function () { addFiles(fileInput.files); fileInput.value = ''; uploadImages(); });
      ['dragenter', 'dragover'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('drag'); });
      });
      drop.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) { addFiles(e.dataTransfer.files); uploadImages(); }
      });
      sketchForm.addEventListener('submit', function (e) {
        if (submitting) return;
        if (!store.length) return;
        e.preventDefault();
        if (store.some(function (item) { return item.state === 'Failed'; })) { message('Please remove failed images or choose them again before sending.', true); return; }
        submitting = true;
        uploadImages().then(function (ok) {
          if (ok) submitWithShopifyCaptcha();
          else submitting = false;
        });
      });
    })();

    /* ---------- Sticky CTA fade on FAQ ---------- */
    var stickyCta = document.getElementById('stickyCta');
    var faqSection = document.getElementById('faq-section');
    if(stickyCta && faqSection){
      var stickyScroll = function(){
        var faqTop = faqSection.getBoundingClientRect().top;
        stickyCta.classList.toggle('hidden', faqTop < window.innerHeight * 0.85);
      };
      window.addEventListener('scroll', stickyScroll, {passive:true});
      stickyScroll();
    }

    /* Map city tooltips */
    var mapWrap = document.querySelector('.world-map-wrap');
    if(mapWrap){
      var mapSvg = mapWrap.querySelector('svg');
      var tip = document.createElement('div');
      tip.className = 'map-tip';
      mapWrap.appendChild(tip);
      document.querySelectorAll('.mdg').forEach(function(g){
        g.addEventListener('mouseenter', function(){
          var t = g.getAttribute('transform');
          var m = t && t.match(/translate\(([^,]+),([^)]+)\)/);
          if(!m) return;
          var pt = mapSvg.createSVGPoint();
          pt.x = parseFloat(m[1]); pt.y = parseFloat(m[2]);
          var sp = pt.matrixTransform(mapSvg.getScreenCTM());
          var wr = mapWrap.getBoundingClientRect();
          tip.textContent = g.dataset.city;
          tip.style.left = (sp.x - wr.left) + 'px';
          tip.style.top = (sp.y - wr.top - 10) + 'px';
          tip.classList.add('show');
        });
        g.addEventListener('mouseleave', function(){ tip.classList.remove('show'); });
      });
    }

    runCounters();

    /* ---- QUIZ ---- */
    (function(){
      var overlay = document.getElementById('quizOverlay');
      if(!overlay) return;
      var closeBtn = document.getElementById('quizClose');
      var allSteps = document.querySelectorAll('#quizOverlay .quiz-step');
      var progressEl = document.getElementById('quizProgress');
      var answers = {};
      var totalSteps = 5;
      for(var qi=0;qi<totalSteps;qi++){ var qs=document.createElement('span'); progressEl.appendChild(qs); }

      function updateProgress(step){
        progressEl.querySelectorAll('span').forEach(function(b,i){ b.classList.toggle('done', i<step-1); });
      }
      function showStep(n){
        allSteps.forEach(function(s){
          s.classList.toggle('active', String(s.dataset.step)===String(n)||(n==='result'&&s.dataset.step==='result'));
        });
        if(n!=='result') updateProgress(n); else updateProgress(totalSteps+1);
      }
      document.querySelectorAll('[data-open-quiz]').forEach(function(el){
        el.addEventListener('click', function(e){ e.preventDefault(); overlay.classList.add('open'); document.body.style.overflow='hidden'; showStep(1); });
      });
      function closeQuiz(){ overlay.classList.remove('open'); document.body.style.overflow=''; }
      closeBtn.addEventListener('click', closeQuiz);
      overlay.addEventListener('click', function(e){ if(e.target===overlay) closeQuiz(); });
      document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeQuiz(); });
      document.querySelectorAll('.quiz-opt').forEach(function(btn){
        btn.addEventListener('click', function(){
          var step=parseInt(btn.closest('.quiz-step').dataset.step);
          answers['step'+step]=btn.dataset.val;
          btn.closest('.quiz-options').querySelectorAll('.quiz-opt').forEach(function(b){ b.classList.remove('sel'); });
          btn.classList.add('sel');
          setTimeout(function(){ showStep(step+1); },220);
        });
      });
      document.querySelectorAll('.quiz-back').forEach(function(btn){
        btn.addEventListener('click', function(){ showStep(parseInt(btn.dataset.back)); });
      });
      document.getElementById('quizSubmit').addEventListener('click', function(){
        var n=document.getElementById('qName').value.trim(), e=document.getElementById('qEmail').value.trim();
        if(!n||!e){ document.getElementById('qEmail').focus(); return; }
        answers.name=n; answers.email=e; showResult();
      });
      function showResult(){
        var recs={
          romantic:{title:'Soft <em>romance</em>',desc:'Flowing silk chiffon, delicate draping, an open back. This is the silhouette language to look for in the collection.'},
          sleek:{title:'Clean <em>elegance</em>',desc:'Minimal seams, column or A-line, letting the fabric speak. Look for the simplest lines in the collection.'},
          dramatic:{title:'Unforgettable <em>drama</em>',desc:'Cathedral train, sculptural bodice, pure presence. Look for the most structured gowns in the collection.'},
          classic:{title:'Timeless <em>grace</em>',desc:'Nothing overdone, nothing forgotten. Ages beautifully in every photograph.'}
        };
        var rec=recs[answers.step2]||recs.classic;
        var intentNote=answers.step3==='readytowear'
          ?'Your look is ready. Browse the collection and your gown could ship within 2 weeks.'
          :answers.step3==='customize'
          ?'We can adjust neckline, sleeves, fabric or back on any ready-to-wear design. €500 covers all changes.'
          :'Your gown will be designed from a blank page. Sketch first, cut nothing until you love it.';
        document.getElementById('quizResult').innerHTML=
          '<div class="quiz-result-tag">Your result</div>'+
          '<h2>'+rec.title+'</h2>'+
          '<p>'+rec.desc+'</p>'+
          '<p style="font-size:12.5px;color:var(--grey);border-top:1px solid var(--line);padding-top:16px;margin-top:0">'+intentNote+'</p>'+
          '<div class="quiz-result-ctas">'+
            '<a href="/pages/process" class="btn btn-primary">Start a free sketch &rarr;</a>'+
            '<a href="/collections/all" class="btn btn-ghost">Browse the collection</a>'+
          '</div>';
        showStep('result');
      }
    })();

  });
})();
